import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  template: '',
  standalone: false
})
export class ConfirmModalComponent {
  @Input() public title: string;
  @Input() public message: string;

  @Input() public acceptLabel: string;
  @Input() public cancelLabel: string;

  @Input() public showCancelButton = true;

  @Output() confirmed = new EventEmitter<boolean>();

  constructor(protected bsModalRef: BsModalRef, protected translate: TranslateService) {
    if (!this.acceptLabel) {
      this.acceptLabel = translate.instant('modal.button.accept');
    }
    if (!this.cancelLabel) {
      this.cancelLabel = translate.instant('modal.button.cancel');
    }
  }

  accept(): void {
    this.confirmed.emit(true);
    this.bsModalRef.hide();
  }

  cancel(): void {
    this.confirmed.emit(false);
    this.bsModalRef.hide();
  }
}
